import { postData } from '../../Survey/helpers/fetch_services';

/** Sends completion confirmation via `POST ld-invitation/completion-email`. */
export async function sendLearningCompletionEmail({
  inviteId,
  packageId,
  userId,
  responseId,
  email,
} = {}) {
  if (!inviteId || !packageId || !responseId || !email?.trim()) {
    return { success: false };
  }

  const result = await postData('ld-invitation/completion-email', {
    invite_id: inviteId,
    package_id: packageId,
    user_id: userId || '',
    response_id: responseId,
    email: email.trim(),
  });

  const payload = result?.data?.data ?? result?.data;
  const sent = payload?.sent === true;

  if (result?.status === 200 || sent) {
    return {
      success: true,
      message: result?.message || '',
    };
  }

  return {
    success: false,
    message: result?.message || 'ld-unable-send-email',
  };
}
